import React from "react";

import { faArrowLeft, faArrowRight } from "@performyard/fontawesome/pro-solid-svg-icons";

import { ButtonStandard } from "../../atoms/ButtonStandard";
import { Icon } from "../../atoms/Icon";
import { useWizard } from "./context";

export const WizardStepNavigationButtons = () => {
	const { isFirstStep, isLastStep, goToNext, goToPrevious, submitLabel, isNextDisabled, isSubmitting } = useWizard();
	const [isNavigating, setIsNavigating] = React.useState(false);
	const isDisabled = isNavigating || isSubmitting || isNextDisabled;

	const handleGoToNext = async () => {
		setIsNavigating(true);
		try {
			await goToNext();
		} finally {
			setIsNavigating(false);
		}
	};

	return (
		<div className="mx-auto flex w-fit gap-2 py-6" data-testid="wizard-nav-buttons">
			{!isFirstStep && (
				<ButtonStandard variant="outline" color="neutral" onClick={goToPrevious} disabled={isDisabled}>
					<span className="flex items-center gap-1">
						<Icon icon={faArrowLeft} color="neutral-5" size={16} />
						Back
					</span>
				</ButtonStandard>
			)}
			<ButtonStandard
				variant="solid"
				color={isLastStep ? "green" : "primary"}
				onClick={handleGoToNext}
				disabled={isDisabled}
			>
				{isLastStep ? (
					(submitLabel ?? "Submit")
				) : (
					<span className="flex items-center gap-1">
						Next
						<Icon icon={faArrowRight} color="neutral-0" size={16} />
					</span>
				)}
			</ButtonStandard>
		</div>
	);
};

WizardStepNavigationButtons.displayName = "WizardStepNavigationButtons";
